module.exports = __webpack_public_path__ + "static/media/01-08.42bd0c35.mp3";